import { usePost } from '../usePost';

const API_URL = import.meta.env.VITE_API_URL;

export function useSalvarPessoaEmail() {
  return usePost({
    url: `${API_URL}/pessoas/salvar-email`,
    config: {
      timeout: 120000,
      getAccessToken: true,
    },
  });
}
